var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 72.9677C57.7599 72.9677 72.9677 57.7599 72.9677 39C72.9677 20.2401 57.7599 5.03226 39 5.03226C20.2401 5.03226 5.03226 20.2401 5.03226 39C5.03226 57.7599 20.2401 72.9677 39 72.9677ZM39 78C60.5391 78 78 60.5391 78 39C78 17.4609 60.5391 0 39 0C17.4609 0 0 17.4609 0 39C0 60.5391 17.4609 78 39 78Z",
    fill: "#255097"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5703 35.8632V30.8594H26.5703V35.8632H50.5703ZM50.5703 46.2879V41.2841H26.5703V46.2879H50.5703Z",
    fill: "#255097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge4);
export default __webpack_public_path__ + "static/media/badge4.85a863e8e3ddd72bef608d3b0dee5576.svg";
export { ForwardRef as ReactComponent };